import axios from "axios";
import firebase from "firebase/compat/app";
import { isNullOrEmpty } from "../config/ENV";
import { toast } from "react-toastify";
import { Stringutility } from "../utilities/stringutility";
toast.configure();

const requestHandler = (request) => {
  document.body.classList.add("loading-indicator");
  const token = window.localStorage.getItem("authToken");
  if (token) {
    request.headers["Authorization"] = "Bearer " + token;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
};

const responseHandler = (response) => {
  document.body.classList.remove("loading-indicator");
  if (response.status === 401) {
    window.location = "/";
  }
  return response;
};

const AxiosInterceptors = axios.create({});

AxiosInterceptors.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

AxiosInterceptors.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

const errorHandler = (error) => {
  // console.log('error '+JSON.stringify(error));
  document.body.classList.remove("loading-indicator");
  if (error.code === "ERR_NETWORK") {
    toast.error("Internal Server Error");
  } else {
    const status = error.response.status;
    const failure_code = error.response.data.failure_code;
    if (status === 400) {
      if (failure_code === "BASICINFO_EXISTS") {
      } else if (failure_code === "INVALID_PROFILE") {
        window.localStorage.setItem("profile", "notcompleted");
        window.localStorage.setItem("basicInfo", "notcompleted");
      }else if (failure_code === "JOB_APPLIED_PREVIOUSLY") {
        toast.error("You have applied job previously");
        window.sessionStorage.removeItem("clickapplybutton");
        window.sessionStorage.removeItem("jobId");
      } else if (failure_code === "INVALID_JOB") {
        toast.error("Invalid job");
        window.sessionStorage.removeItem("clickapplybutton");
        window.sessionStorage.removeItem("jobId");
      }else if(failure_code=='JOB_IS_NOT_ACTIVE'){
        toast.error("Invalid job");
        window.sessionStorage.removeItem("clickapplybutton");
        window.sessionStorage.removeItem("jobId");
      }else if(failure_code=='JOB_REQ_IS_NOT_LIVE'){
        toast.error("Job req is not live");
        window.sessionStorage.removeItem("clickapplybutton");
        window.sessionStorage.removeItem("jobId");
      }else if(failure_code=='JOB_REQ_IS_ALREADY_CLOSED'){
        toast.error("Job req is already closed");
        window.sessionStorage.removeItem("clickapplybutton");
        window.sessionStorage.removeItem("jobId");
      }
    } else if (status == 401) {
      if (failure_code === "INVALID_USER") {
        window.location.href = "/";
      } else if (
        failure_code === "INVALID_USER_SESSION"
      ) {
       sessionExpired();
      } else if (
       failure_code === "INVALID_BEARER_TOKEN" ||
        failure_code === "MISSING_BEARER_TOKEN"
      ) {
       sessionExpired();
      }
    } else if (error.response.status === 404) {
      // window.localStorage.setItem("account", "NewUser");
      // window.location.href = "/";
      // window.localStorage.setItem("account", "NewUser");
      // window.localStorage.clear();
      // sessionStorage.clear(); 
      // window.location.href = "/";
    }
  }
  return Promise.reject(error);
};

const handleFailureCode = (failure_code) => {
  if (failure_code === "ACCOUNT_IN_USE") {
    toast.error("Account in use");
  }
  if (failure_code === "ACCOUNT_ADDRESS_IN_USE") {
    toast.error("Account address in use");
  }
  if (failure_code === "ACCOUNT_BENEFITS_IN_USE") {
    toast.error("Account benefits in use");
  }
};

const clearStorage = () => {
  toast.error("Session Expired. Login again");
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.href = "/";
    })
    .catch(function () {
      window.location.href = "/";
    });
};

const sessionExpired = () => {
  const p = window.localStorage.getItem("page");
  if (isNullOrEmpty(p)) {
    if (window.localStorage.getItem("user") !== null) {
      closeSession();
    } else {
      window.localStorage.clear();
      sessionStorage.clear();
    }
  } else {
    closeSession();
  }
};

const closeSession = () => {
  toast.error("Session Expired. Login again");
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.href = "/";
    })
    .catch(function () {
      window.location.href = "/";
    });
};

export default AxiosInterceptors;
